'use strict';
namespace TR {
    function HeadingOverlayBanner() {
        return {
            restrict: 'C',
            link($scope, $element) {
                if ($element.is('[no-heading-overlay-banner]')) {
                    return;
                }
                let text = $element.text().toLowerCase().indexOf('sale') > -1 ?
                    TRPCONFIG.Domain.HeadingOverlayBannerMessageShort :
                    TRPCONFIG.Domain.HeadingOverlayBannerMessage;
                let classes = 'sc-c-panel--quinary sc-c-panel--lighten80 sc-c-panel--gutters-xs u-text--centered';
                let html = `<div class="${classes}">
                            <h6 class="sc-o-hero-heading ">${text}</h6>
                           </div>`;
                let div = $(html);
                div.insertBefore($element);
            },
        };
    }

    if (TRPCONFIG.Domain.HeadingOverlayBannerMessage) {
        angular
            .module('TR')
            .directive('scCHero', HeadingOverlayBanner)
            .directive('heroImage', HeadingOverlayBanner);
    }
}
